// extracted by mini-css-extract-plugin
export default {"externalContainer":"view-external_externalContainer__oMWFY","externalContainerExpanded":"view-external_externalContainerExpanded__Xb+HW"};